import { transitioningDetailsResource } from './services';

export const resources = [transitioningDetailsResource];
export { transitioningDetailsResource } from './services';
export type { TransitioningDetailsResponse } from './services/types';
